export const CONFIRM_AND_BOOK = "Confirm and book";
